var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCopyLink = function SvgIconCopyLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    fillRule: "evenodd",
    d: "M10.867 1.416c0-.345.28-.625.625-.625h1.258c2.871 0 5.209 2.347 5.209 5.208 0 2.871-2.347 5.209-5.208 5.209h-1.259a.625.625 0 1 1 0-1.25h1.258a3.972 3.972 0 0 0 3.959-3.959 3.972 3.972 0 0 0-3.958-3.958h-1.259a.625.625 0 0 1-.625-.625ZM.042 6A5.216 5.216 0 0 1 5.25.79H6.5a.625.625 0 0 1 0 1.25H5.25a3.966 3.966 0 0 0-3.958 3.958A3.972 3.972 0 0 0 5.25 9.958H6.5a.625.625 0 0 1 0 1.25H5.25C2.38 11.208.042 8.86.042 5.999Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    fillRule: "evenodd",
    d: "M5.042 6c0-.345.28-.625.625-.625h6.667a.625.625 0 0 1 0 1.25H5.667A.625.625 0 0 1 5.042 6Z",
    clipRule: "evenodd"
  })));
};
export default SvgIconCopyLink;